import { ErrorBase } from './base';

export class DuplicateImportServiceError extends ErrorBase {
	constructor(serviceName?: string) {
		super(`Duplicate import service '${serviceName}' error!`);
	}
}
